import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
  fonts: {
    heading: 'Open Sans',
    body: 'Open Sans',
	input: 'Open Sans',
  
  },
  styles: {
    global: {
      body: {
        bg: "tomato"
      }
    }
  }
})

export default theme